import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface ModalPageTitleProps {
  title: string;
  subtitle?: string;
}

export default function ModalPageTitle(props: ModalPageTitleProps) {
  const { title, subtitle } = props;
  return (
    <>
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: 30,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <>
          <div style={{ marginBottom: '0.5rem' }} />
          <div>
            <Trans>
              <Typography variant="subtitle2">{subtitle}</Typography>
            </Trans>
          </div>
        </>
      )}
    </>
  );
}
